import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class sessionPrototypesDB extends GenericDB {
  constructor(clinicId) {
    super('', 'clinicSettings.sessionPrototypes');
    this.clinicId = clinicId;
  }

  async setClinicId(clinicId) {
    this.clinicId = clinicId;
  } // setClinicId()

  getCollectionRef() {
    return collection(db, 'clinicSettings', this.clinicId, 'sessionPrototypes');
  }
}
